<template>
  <Popover
    :popper-class="`pg-point-item__popper ${popperClass ?? ''}`"
    placement="bottom-start"
    trigger="hover"
    v-model="visible"
    :visible-arrow="false"
  >
    <div
      slot="reference"
      ref="divRef"
      class="pg-point-item"
      :style="{ left: `${point.x}px`, top: `${point.y}px` }"
      @mousedown="onMousedown"
      @mousemove="onMousemove"
      @mouseleave="onMouseleave"
      @mouseup="onMouseup"
    ></div>
    <slot>
      <div class="pg-point-item-pop">
        <div class="pg-point-item-pop-row">
          <span>编号</span>
          <span>{{ point.location?.code }}</span>
        </div>
        <div class="pg-point-item-pop-row">
          <span>名称</span>
          <span>{{ point.location?.name }}</span>
        </div>
      </div>
    </slot>
  </Popover>
</template>
<script setup>
import { ref } from 'vue'
import { Popover } from 'element-ui'

const emit = defineEmits(['on-xy'])
const props = defineProps({
  point: Object,
  drag: Boolean,
  popperClass: String,
  imgXy: Function,
})

const visible = ref(false)

const isDown = ref(false)
const downXy = {
  x: 0,
  y: 0,
}
const divRef = ref(null)
//鼠标按下
const onMousedown = (event) => {
  if (!props.drag) return
  isDown.value = true
  downXy.x = event.clientX
  downXy.y = event.clientY
}
//鼠标移动
const onMousemove = (event) => {
  if (!props.drag) return
  if (isDown.value) {
    visible.value = false
    const changeXy = { x: event.clientX - downXy.x, y: event.clientY - downXy.y }
    changeXy.x = props.point.x + changeXy.x
    changeXy.y = props.point.y + changeXy.y
    const parentXy = props.imgXy?.()
    if (
      changeXy.x >= 0 &&
      changeXy.y >= 0 &&
      changeXy.x <= parentXy.width - 20 &&
      changeXy.y <= parentXy.height - 20
    ) {
      emit('on-xy', changeXy)
      divRef.value.style.left = `${changeXy.x}px`
      divRef.value.style.top = `${changeXy.y}px`
    }

    downXy.x = event.clientX
    downXy.y = event.clientY
  }
}
//鼠标移除
const onMouseleave = () => {
  if (!props.drag) return
  isDown.value = false
}
//鼠标松开
const onMouseup = () => {
  if (!props.drag) return
  visible.value = true
  isDown.value = false
}
</script>
<style lang="scss">
@import '../style/point-item.scss';
</style>
